const EC = require('elliptic').ec;
const ec = new EC('secp256k1');
const aesctr = require('./aes-ctr');
const pbkdf2 = require('pbkdf2')
const cryptoRandomString = require('crypto-random-string');
const utils = require('../util/utils');
class ECIES {

    // appends 04 if not present in publicKey
    static formatPublickey(publicKey) {
        if (publicKey.startsWith("0x")) {
            publicKey = publicKey.substr(2);
        }
        if (publicKey.length === 128) {
            publicKey = "04" + publicKey;
        }
        return publicKey
    }

    static getPublicKey(cipherText) {
        const publicKey1 = cipherText.substr(0, 128);
        const publicKey2 = cipherText.substr(-128);
        const selfPublicKey = utils.getFromLocalStorage("publicKey");
        if (publicKey1 === selfPublicKey)
            return publicKey2;
        return publicKey1;
    }

    // returns shared key of hex formatted publicKey and privateKey (without leading 0x)
    static getSharedKey(privateKey, publicKey) {
        publicKey = ECIES.formatPublickey(publicKey);
        privateKey = ec.keyFromPrivate(privateKey, 'hex');
        publicKey = ec.keyFromPublic(publicKey, 'hex');
        let sharedKey = privateKey.derive(publicKey.getPublic());
        sharedKey = sharedKey.toString('hex');
        return sharedKey;
    }

    // retruns HMAC-SHA512
    static getDigest(sharedKey, randomStr, encryptionVersion) {
        //for supporting GRN Manager
        if (encryptionVersion === "1") {
            sharedKey = "";
        }
        let digest = pbkdf2.pbkdf2Sync(sharedKey, randomStr, 2048, 256, 'sha512').toString('hex');
        return digest;
    }

    static encrypt(privateKey, receiverPublicKey, message, initialRandomStr, senderPublicKey) {
        // FIXME/TODO: Genrate strong random string hash b/w buyer, seller and 3rd Party.
        // We commented below code for supporting 3rd party can able to sign/modify the
        // JSONLd. Changed due to GRN Manager can able to add document.
        const sharedKey = ECIES.getSharedKey(privateKey, receiverPublicKey);
        const randomStr = initialRandomStr || cryptoRandomString({ length: 512, type: "base64" });
        const encryptedRandomStr = aesctr.encrypt(randomStr, sharedKey);
        const encryptionVersion = "1";
        const receiptKey = ECIES.getDigest(sharedKey, randomStr, encryptionVersion);

        const cipherText = aesctr.encrypt(message, receiptKey);
        let len = encryptedRandomStr.length;
        len = len.toString(16);
        // len = “000” + len;
        len = len.slice(-3);
        if (!senderPublicKey) {
            senderPublicKey = utils.getPublicKey();
        }
        return senderPublicKey + encryptionVersion + len + encryptedRandomStr + cipherText + receiverPublicKey;
    }

    static encryptForSubscriber(receiverPublicKey, message, initialRandomStr, encryptedRandomStr, senderPublicKey) {
        const encryptionVersion = "1";
        const receiptKey = ECIES.getDigest("", initialRandomStr, encryptionVersion);
        const cipherText = aesctr.encrypt(message, receiptKey);
        let len = encryptedRandomStr.length;
        len = len.toString(16);
        // len = “000” + len;
        len = len.slice(-3);
        if (!senderPublicKey) {
            senderPublicKey = utils.getPublicKey();
        }
        return senderPublicKey + encryptionVersion + len + encryptedRandomStr + cipherText + receiverPublicKey;
    }

    static decrypt(privateKey, cipherText) {
        try {
            const publicKey = ECIES.getPublicKey(cipherText);
            const sharedKey = ECIES.getSharedKey(privateKey, publicKey);
            cipherText = cipherText.slice(128, -128);
            const encryptionVersion = cipherText.substr(0, 1);
            let randomStrLength = cipherText.substr(1, 3);
            randomStrLength = parseInt(randomStrLength, 16);
            const messageCipher = cipherText.substr(randomStrLength + 4);

            // decrypt with receipt key for subscriber
            if (privateKey.length === 512) {
                if (encryptionVersion === "1") {
                    privateKey = ECIES.getDigest(sharedKey, privateKey, encryptionVersion);
                }
                return aesctr.decrypt(messageCipher, privateKey);
            }

            const randomStr = ECIES.getDecryptedRandomString(privateKey, publicKey, cipherText);
            const receiptKey = ECIES.getDigest(sharedKey, randomStr, encryptionVersion);

            return aesctr.decrypt(messageCipher, receiptKey);
        } catch (e) {
            console.error("Error in decrypting", e);
            throw new Error(e);
        }
    }

    static getDecryptedRandomString(privateKey, publicKey, cipherText) {
        try {
            const sharedKey = ECIES.getSharedKey(privateKey, publicKey);
            const encryptedRandomStr = ECIES.getEncryptedRandomString(cipherText);
            return aesctr.decrypt(encryptedRandomStr, sharedKey);
        } catch (e) {
            console.error("Error in decryptingRandomString", e);
            throw new Error(e);
        }
    }

    static getEncryptedRandomString(cipherText) {
        let randomStrLength = cipherText.substr(1, 3);
        randomStrLength = parseInt(randomStrLength, 16);
        const encryptedRandomStr = cipherText.substr(4, randomStrLength);
        return encryptedRandomStr;
    }

    static decryptWithReceiptKey(receiptCipher, receiptKey) {
        try {
            let randomStrLength = receiptCipher.substr(1, 3);
            randomStrLength = parseInt(randomStrLength, 16);
            receiptCipher = receiptCipher.substr(randomStrLength + 4);
            return aesctr.decrypt(receiptCipher, receiptKey);
        } catch (e) {
            console.error("Error in decryptingReceiptKey", e);
            throw new Error(e);
        }
    }

    static getReceiptKey(privateKey, cipherText) {
        const publicKey = ECIES.getPublicKey(cipherText);
        const sharedKey = ECIES.getSharedKey(privateKey, publicKey);
        cipherText = cipherText.slice(128, -128);
        const encryptionVersion = cipherText.substr(0, 1);
        const randomStr = ECIES.getDecryptedRandomString(privateKey, publicKey, cipherText);
        if (encryptionVersion === "1")
            return randomStr;
        return ECIES.getDigest(sharedKey, randomStr);
    }
}

export default ECIES;

// module.exports = ECIES;
// const fs = require('fs');
// let file = fs.readFileSync('/Users/divum/Desktop/test.json')
// let encrypted = "02d8U2FsdGVkX18sT1pdq6GnaTroEpqsCvxRKpSenRx1tZaTrTK+mVGL5coegT7OZUesHc4LyFbREJ0tZQFdoY5+lwPM9lHXdkQ7JN0OeFVBrsPCPAupcxhJXTOfhnU17TM8yb8xUOhUtrdLH1DMPuvmBAm6SFQx0l76xlMp1j9KkC0AgC9vALszgewqeqELBPXgs8tF6xVujItEakM8m1BIefUknxz/8Zzv1n8ik/OBHwWpEBtq/2Du5iAFWxIZ5aNfMJeYGsBByn6UBPQFcIEzbdPISHzKUCIWq+Hs2qjgwXjlS9i4gVe29gS/6rgVtP0vJ6kItDuaPr3jZVFn0BfTXIOQ4CdS5idReoy1/yBm8A7a+TABNbZh4qqBdrAND+/fMVOSaw+zDVfYmuplLTEYH5QS2plPLZxHh7sc36UdPgrs2mCffr56WY1ZBuG36oHvBYwZ6j2YFIh9VqkfkjEd4+cNIMC6MwAbzh3nUX2mw0raV+Xor7aFmsI5uS+RSnqHDYBjCY+zStMS7DpuLA5581QaRZi0yNcUOBEwgKD+W1sBoqhwUMI9wpPEnI2s9Ucs0x9g1Ih2M2K5iaXTeukfsF3Luu0IMWGnYEERNTq+ONMnPWh5HzcvrZ58QGCCfNZc4cMw2aNUj636Npz4i+SD7ha9ISztd2olXiJzxunT1CddVZBVmAOzJVPSM+YQXQi05O7e2+Af5OFdY5NDE78mxQ==U2FsdGVkX1/UT1Q0S1/zqbDmRlHlmT/OuG3FoFz87rGM2DpLs3RoFMNXrKnVrondf7+vA3/HEbaevWs54X9TCcfFVrsiGtGK8m4cTwi4/bdKCJw8RS5VMyGEhOnKGx9FcaJNnM0jULGAFRWfd24vSiIM2ZJgpO3WQYBPC5s+DkREEh1mccTKwXcxi6mk/ag982yCawT+YHu0vhAgpM04Xubyx7PXfygQ69RuJ+pNOtSiideq45BO5BkyMi5ZAdC6pUDvzFvQuYFpyUgEwQq5B/VPenMhKkGBkbdhcCnElk0YomS/16XZz+gz1DD92GoBCM9vH9R+n3uUT26SMFKO3DwDSs50tiQkwDiuhn49gCvZsWVlji9qztT1YeYRx72BLQ2MA4+ae6uWItpCK8jIlLWPESDkrxfCE4Hz28C5ECNeCHFN4T+2TGZd8m/P++/qejEsDC3jXvL8aJCFOo0vgtpdfNgVKqZFOrQbTnp8yOxDKJvOm77PiN5o+OBgjf6A5tqKBWTxtvElN3a+sY+REgfpLncIz6gYGn205vWD5OH2yRsNKdJn/jwWA4gTlzd44O4o4VO6mwHRVDujZURQZKTqPtvBQ8jzN9qmyYhI369Pkc2H9Wc1X0BrtBBwFZgCRSfpqMzINXjmx5Ik7zGEP/iZNHo8kB76DYElt6Fmemry+GE8MdvhXCZn1p2v5tXq9klnCXFE+gv0KzHAN8gNCOFIC55PM3LPAdUwVHTgVPDXKonOKemTdHslioBrlIM1G0cyec8Pi5Ii0pg1h0dzSIodgZOnH4/xNBvgwzy5NvHet15l17XCOs1HQghzk+3INjItB2K+LPb0J9jDsZEg0DL+4lgjSldgVsljeEs99/mXi+k2+OOF3i+/rcxMPlyb0F51XDJqrAjonN7WNTBMdnQGzdIFyV5FlFRqfN3xe6dE0Ht17QRV9SRl5Eq64UUKo9MfuMgkix9VpG4eSIaoJQXELJgQc/PI2a9rnJhH/rGdBuCVR53Xoo5L1gyNOmpynRMahq773F6yPmSyXRfkxCq11v7WYUM3G7dOggOGyVrizGpcjXR6ZIfM6UyErbNAzDvZTVILOiQWGQR+tpsdf5LLVWGxdm2sjJrMQ0lrfhZj99Tokdbc50LdLQoHmMbl1+dhJEHWoIpCT/U7DkECgu7XKvu7m3UudnK0LeqAp8yFYsEhZMJM4vw5tyyKXce5vH+gTeZG4di96ZzJ2xbF+CO443H7i2i7/b+IW0laCQ7mYd5/a8DOFuzGL3Tn0/JtRz5wTJvj09Yj0G2LeE0PLZvv6krVuSZaMjjQFO8Zh6q8s/4AruoK757QOK3uszpGl74peKQzRRRW6SyfnD3MDCMwWyKwixEsAUiGXMf/ZqDUP+LIFnEZP/1SoSFYJDXg1RBLDfOoPisJorakuIXvEClbVa8/S6ZsMZiufEZVeZ0="
// let obj = new ECIES();
// var alicePub = "5e4162a99f0dee05f75ed1645c876e11f779a9e9591179c91495d64d9b51797620e7c068c4cad7c16aee15e04e151f9f5b158ced443d3b94b7e0d3da9f211d9c"
// var alicePriv = "024764dbbc02086e0eb28541c30c304ecd7255c9bed65263216ae20dfb933e4d"
// var bobPub = "94d44281feb6e8b5f3de83b1a84efedfd2fdce49bfc44fcd680f71c35ecf9d67f852881caa718b4e6cd4ec4b0352da092f40b8c259ca7c10db1329e27f8840c5"
// var bobPriv = "81f75436191d56df83a7ba368c9d62b7bcc9e711d6c04211a2afeef5207ebefe"
// let encrypted = obj.encrypt(alicePriv, bobPub, "file.toString()");
// let decrypted = obj.decrypt(bobPriv, alicePub, encrypted);
// console.log(obj.getSharedKey(alicePriv, bobPub));
// console.log(obj.getSharedKey(bobPriv, alicePub));
